import React from "react";
import Typed from "react-typed";
import { Link } from "react-scroll";
import 'react-typed/dist/animatedCursor.css'

function Herosection(props) {
  const { x, y } = props.position;
  const { height, width } = props.elementDimensions;
  const activeParallax = (depth = 15) => {
    let posX = (width / 2 - x) / depth;
    let posY = (height / 2 - y) / depth;
    return {
      transform: `translate(${posX}px, ${posY}px)`,
    };
  };
    
  return (
    <section
      id="home"
      className={
        props.light
          ? "home d-flex align-items-center light"
          : "home d-flex align-items-center"
      }
    >
      <div className="container">
        <div className="intro">
          <img src="images/avatar-1.svg" alt="Bolby" className="mb-4" />

          <h1 className="mb-2 mt-0">Jesus Nieves</h1>                        
            <p> 
              <code>       
              <span style={{color: "#cc99cd"}}>let</span>{" "}
              <Typed
                strings={[
                  "",
                  '<span style="color: #ccc">bachelorsDegree</span> <span style="color: #67cdcc">=</span> <span style="color: #7ec699">"Software Engineer"</span>',                
                  '<span style="color: #ccc">mainTitle</span> <span style="color: #67cdcc">=</span> <span style="color: #7ec699">"iOS Developer"<span>',
                  '<span style="color: #ccc">secondaryTitle </span> <span style="color: #67cdcc">=</span> <span style="color: #7ec699">"Front-end Web Developer"<span>',
                  '<span style="color: #ccc">passion </span> <span style="color: #67cdcc">=</span> <span style="color: #7ec699">"UI / UX Design"<span>'
                ]}
                showCursor={true}
                contentType="html"
                typeSpeed={80}
                backSpeed={40}
                loop
              /> 
              </code>                     
            </p>
          

          <ul className="social-icons light list-inline mb-0 mt-4">
            <li className="list-inline-item">
              <a href="https://www.behance.net/nievesjesus">
                <i className="fab fa-behance"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="https://twitter.com/nievesjesus">
                <i className="fab fa-twitter"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="https://medium.com/@nievesjesus">
                <i className="fab fa-medium"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="https://ar.linkedin.com/in/nievesjesus">
                <i className="fab fa-linkedin"></i>
              </a>
            </li>
            <li className="list-inline-item">
              <a href="https://github.com/nievesjesus">
                <i className="fab fa-github"></i>
              </a>
            </li>
          </ul>

          <div className="mt-4">
            <Link
              className="btn btn-default"
              to="section-about"
              spy={true}
              smooth={true}
              duration={500}
            >
              More about me
            </Link>         
          </div>
        </div>

        <div className="scroll-down">
          <Link
            to="section-about"
            spy={true}
            smooth={true}
            duration={500}
            className="mouse-wrapper"
          >
            <span>Scroll Down</span>
            <span className="mouse">
              <span className="wheel"></span>
            </span>
          </Link>
        </div>

        <div className="parallax" data-relative-input="true">
          <svg
            width="23"
            height="29"
            className="layer p1 apple"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(15)}
          >

          <path fill="#CCD0D2" fillRule="evenodd" d="M15.8,4.41A5.65,5.65,0,0,0,17.43,0a7.38,7.38,0,0,0-4.61,2.09,5.43,5.43,0,0,0-1.66,4.27A6.13,6.13,0,0,0,15.8,4.41Zm3.35,11.17a6.48,6.48,0,0,1,3-5.45,6.41,6.41,0,0,0-5.08-2.84C14.9,7.06,12.85,8.6,11.75,8.6S9,7.32,7.16,7.35a6.78,6.78,0,0,0-5.74,3.59C-1,15.33.79,21.82,3.18,25.38,4.34,27.12,5.74,29.07,7.56,29s2.43-1.17,4.56-1.17S14.84,29,16.7,29s3.1-1.77,4.25-3.52a15.69,15.69,0,0,0,1.93-4.07A6.31,6.31,0,0,1,19.15,15.58Z"/>
          </svg>

          <svg
            width="20"
            height="29"
            className="layer p2 figma"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(20)}
          >
            <path d="M5.17,29A4.84,4.84,0,0,0,10,24.17V19.33H5.17a4.84,4.84,0,1,0,0,9.67Z" fill="#0acf83"/>
            <path d="M.33,14.5A4.84,4.84,0,0,1,5.17,9.67H10v9.66H5.17A4.84,4.84,0,0,1,.33,14.5Z" fill="#a259ff"/>
            <path d="M.33,4.83A4.84,4.84,0,0,1,5.17,0H10V9.67H5.17A4.84,4.84,0,0,1,.33,4.83Z" fill="#f24e1e"/>
            <path d="M10,0h4.83a4.84,4.84,0,1,1,0,9.67H10Z" fill="#ff7262"/>
            <path d="M19.67,14.5a4.84,4.84,0,1,1-4.84-4.83A4.84,4.84,0,0,1,19.67,14.5Z" fill="#1abcfe"/>
          </svg>

          <svg
            width="27"
            height="29" 
            className="layer p3 swift"  
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(25)}
            >
          <path fill="#FF5722" d="M16.6,2.3c11.9,7.9,8,16.6,8,16.6s3.4,3.7,2,7c0,0-1.4-2.3-3.7-2.3c-2.2,0-3.6,2.3-8.1,2.3
            C4.8,26,0,17.7,0,17.7c9.1,5.9,15.3,1.7,15.3,1.7C11.2,17.1,2.5,5.9,2.5,5.9c7.6,6.3,10.9,8,10.9,8c-2-1.6-7.5-9.3-7.5-9.3
            C10.3,9,19,15,19,15C21.5,8.3,16.6,2.3,16.6,2.3z"/>
          </svg>  

          <svg
            width="29"
            height="27"
            className="layer p4 sketch"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(10)}
          >
            <g>
              <polygon points="14.5 0.38 6.33 1.24 0 9.74 14.5 26.62 29 9.74 22.67 1.24 14.5 0.38" fill="#fdb300"/>
              <polygon points="0 9.74 14.5 26.62 5.87 9.74 0 9.74" fill="#eb6c00"/>
              <polygon points="23.13 9.74 14.5 26.62 29 9.74 23.13 9.74" fill="#eb6c00"/>
              <polygon points="5.87 9.74 14.5 26.62 23.13 9.74 5.87 9.74" fill="#fdad00"/>
              <polygon points="6.33 1.24 5.87 9.74 14.5 0.38 6.33 1.24" fill="#fdd231"/>
              <polygon points="23.13 9.74 22.67 1.24 14.5 0.38 23.13 9.74" fill="#fdd231"/>
              <polygon points="23.13 9.74 29 9.74 22.67 1.24 23.13 9.74" fill="#fdad00"/>
              <polygon points="0 9.74 5.87 9.74 6.33 1.24 0 9.74" fill="#fdad00"/>
              <polygon points="14.5 0.38 5.87 9.74 23.13 9.74 14.5 0.38" fill="#feeeb7"/>
            </g>            
          </svg>

          <svg
            width="29" 
            height="25.83"
            className="layer p5 react"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(8)}
          >
            <g>
              <path d="M29,12.92C29,11,26.59,9.17,22.91,8c.85-3.75.47-6.75-1.2-7.7A2.52,2.52,0,0,0,20.39,0V1.32a1.35,1.35,0,0,1,.67.16c.81.46,1.15,2.21.88,4.47a16.71,16.71,0,0,1-.3,1.74,29,29,0,0,0-3.75-.64,29,29,0,0,0-2.46-3c1.93-1.79,3.73-2.77,5-2.77V0h0c-1.62,0-3.75,1.16-5.9,3.17C12.34,1.17,10.21,0,8.58,0V1.34c1.23,0,3,1,5,2.76a26.4,26.4,0,0,0-2.44,3,27.2,27.2,0,0,0-3.76.65A16.48,16.48,0,0,1,7,6c-.28-2.26.07-4,.86-4.48a1.29,1.29,0,0,1,.68-.15V0h0A2.68,2.68,0,0,0,7.25.36c-1.66,1-2,3.94-1.18,7.69C2.39,9.19,0,11,0,12.92s2.41,3.74,6.09,4.87c-.85,3.76-.47,6.75,1.2,7.7a2.53,2.53,0,0,0,1.33.34c1.62,0,3.75-1.16,5.9-3.17,2.16,2,4.28,3.14,5.91,3.14a2.55,2.55,0,0,0,1.33-.33c1.67-1,2-3.94,1.18-7.69C26.61,16.65,29,14.83,29,12.92ZM21.3,9c-.22.77-.49,1.55-.79,2.34-.25-.47-.5-1-.78-1.42s-.56-.93-.85-1.38C19.72,8.63,20.53,8.78,21.3,9Zm-2.7,6.3c-.46.8-.94,1.55-1.43,2.26-.88.07-1.77.11-2.67.11s-1.79,0-2.66-.11c-.49-.7-1-1.45-1.43-2.24s-.86-1.56-1.23-2.36c.37-.79.78-1.58,1.22-2.36S11.34,9,11.83,8.32q1.32-.12,2.67-.12c.89,0,1.79,0,2.66.11.49.7,1,1.46,1.43,2.25s.86,1.56,1.23,2.35C19.45,13.7,19,14.49,18.6,15.27Zm1.91-.77c.31.79.59,1.58.81,2.35-.77.19-1.59.35-2.43.48.29-.46.58-.93.85-1.41S20.26,15,20.51,14.5Zm-6,6.31a24.21,24.21,0,0,1-1.64-1.89c.53,0,1.07,0,1.62,0s1.11,0,1.65,0A22.21,22.21,0,0,1,14.51,20.81Zm-4.4-3.48c-.84-.13-1.65-.28-2.42-.47.22-.76.49-1.55.8-2.34.24.48.49,1,.77,1.42S9.82,16.88,10.11,17.33ZM14.48,5a24.76,24.76,0,0,1,1.65,1.9c-.54,0-1.08,0-1.63,0s-1.11,0-1.64,0A22.6,22.6,0,0,1,14.48,5ZM10.11,8.51c-.29.45-.58.92-.85,1.4s-.53.94-.77,1.42c-.32-.8-.59-1.59-.82-2.36C8.45,8.79,9.26,8.63,10.11,8.51Zm-5.35,7.4c-2.09-.9-3.45-2.07-3.45-3s1.36-2.11,3.45-3c.51-.21,1.06-.41,1.64-.59a27.49,27.49,0,0,0,1.33,3.6,27.16,27.16,0,0,0-1.32,3.58A16.71,16.71,0,0,1,4.76,15.91Zm3.18,8.44c-.81-.46-1.15-2.21-.88-4.47a16.71,16.71,0,0,1,.3-1.74,30.73,30.73,0,0,0,3.75.65,30,30,0,0,0,2.46,2.95c-1.93,1.79-3.73,2.77-5,2.77A1.35,1.35,0,0,1,7.94,24.35Zm14-4.5c.28,2.26-.07,4-.86,4.48a1.29,1.29,0,0,1-.68.15c-1.23,0-3-1-5-2.75a27.34,27.34,0,0,0,2.44-2.95,27.2,27.2,0,0,0,3.76-.65A17,17,0,0,1,22,19.85Zm2.28-3.94c-.51.22-1.07.41-1.64.59a29.62,29.62,0,0,0-1.33-3.6,28.55,28.55,0,0,0,1.31-3.58c.59.19,1.14.39,1.66.6,2.09.9,3.45,2.07,3.45,3S26.33,15,24.24,15.91Z" fill="#61dafb"/>
              <circle cx="14.49" cy="12.92" r="2.7" fill="#61dafb"/>
            </g>
          </svg>

          <svg
            width="26"
            height="29"
            className="layer p6 node"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(18)}
          >
            <path d="M13,29a2.42,2.42,0,0,1-1.12-.29L8.34,26.6c-.54-.29-.27-.4-.11-.45a6.39,6.39,0,0,0,1.6-.72.25.25,0,0,1,.27,0l2.71,1.62a.31.31,0,0,0,.32,0l10.63-6.15a.31.31,0,0,0,.16-.3V8.35a.3.3,0,0,0-.16-.29L13.13,1.93a.36.36,0,0,0-.32,0L2.18,8.06A.35.35,0,0,0,2,8.35V20.63a.37.37,0,0,0,.16.3l2.91,1.68c1.57.8,2.55-.14,2.55-1.07V9.42A.33.33,0,0,1,8,9.1H9.32a.32.32,0,0,1,.32.32V21.54c0,2.1-1.14,3.33-3.14,3.33a4.55,4.55,0,0,1-2.45-.67l-2.8-1.59A2.26,2.26,0,0,1,.13,20.66V8.38a2.26,2.26,0,0,1,1.12-2L11.88.28a2.4,2.4,0,0,1,2.24,0L24.75,6.43a2.26,2.26,0,0,1,1.12,2V20.66a2.26,2.26,0,0,1-1.12,1.95L14.12,28.76A2.75,2.75,0,0,1,13,29Zm3.28-8.45c-4.67,0-5.62-2.13-5.62-3.94a.32.32,0,0,1,.32-.32h1.38a.27.27,0,0,1,.29.27c.22,1.41.83,2.1,3.65,2.1,2.24,0,3.2-.5,3.2-1.7,0-.69-.27-1.2-3.76-1.55-2.9-.29-4.71-.93-4.71-3.25,0-2.16,1.81-3.43,4.85-3.43,3.41,0,5.09,1.17,5.3,3.73a.4.4,0,0,1-.08.23.29.29,0,0,1-.21.11H19.5a.31.31,0,0,1-.29-.24c-.32-1.46-1.15-1.94-3.33-1.94-2.45,0-2.75.85-2.75,1.49s.35,1,3.65,1.44,4.83,1,4.83,3.33-1.95,3.67-5.33,3.67Z" fill="#539e43"/>
          </svg>

          <svg
            width="29"
            height="24"
            className="layer p7 bitrise"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(22)}
          >
            <path d="M14.22,4.19h.84c3.62,0,6.38.12,8.14.23h.2a4.18,4.18,0,0,1,3.83,3.23l.07.28c.34,1.49.8,3.59,1.11,5.69l.06.41c.21,1.47.39,3.19.52,5.11a4.22,4.22,0,0,1-4,4.49l-.73,0c-2.46.11-5.91.22-9.58.23H14c-3.54,0-6.87-.13-9.25-.23l-.73,0a4.22,4.22,0,0,1-4-4.49l0-.38c.13-1.76.28-3.34.47-4.72l.05-.29c.33-2.28.83-4.57,1.19-6.1A4.19,4.19,0,0,1,5.54,4.43l.61,0c1.81-.11,4.54-.21,8.07-.21Zm.57,2h-.55c-3.86,0-6.75.13-8.51.25a2.23,2.23,0,0,0-2,1.71l-.09.37C3.26,10,2.82,12,2.53,14.05l0,.28c-.21,1.42-.37,3.09-.49,5a2.22,2.22,0,0,0,2.12,2.37l1,0c2.42.1,5.74.21,9.27.22H15c3.89,0,7.5-.15,9.89-.26a2.2,2.2,0,0,0,1.56-.74A2.46,2.46,0,0,0,27,19.28l0-.37c-.14-1.84-.3-3.47-.5-4.86-.33-2.21-.83-4.44-1.17-5.93a2.21,2.21,0,0,0-2-1.71l-.54,0c-1.79-.1-4.49-.2-8-.21ZM17.72,16a3.23,3.23,0,0,1-6.45.05V16ZM7.29,12a2,2,0,0,1,2,2v0h-4A2,2,0,0,1,7.29,12Zm14.42,0a2,2,0,0,1,2,2v0h-4A2,2,0,0,1,21.71,12ZM14.5.1a1.25,1.25,0,0,1,1.24,1.24A1.24,1.24,0,1,1,14.5.1Z" fill="#683d87"/>
          </svg>

          <svg
            width="29"
            height="29"
            className="layer p8 github"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(15)}
          >
            <path d="M14.5.36A14.5,14.5,0,0,0,9.92,28.62c.72.13,1-.32,1-.7s0-1.49,0-2.7C6.85,26.1,6,23.51,6,23.51a3.81,3.81,0,0,0-1.61-2.12c-1.31-.9.1-.88.1-.88A3,3,0,0,1,6.71,22a3.09,3.09,0,0,0,4.22,1.21,3.1,3.1,0,0,1,.92-1.94c-3.22-.37-6.6-1.61-6.6-7.17a5.59,5.59,0,0,1,1.49-3.89,5.21,5.21,0,0,1,.14-3.84s1.22-.39,4,1.49a13.69,13.69,0,0,1,7.26,0c2.77-1.88,4-1.49,4-1.49a5.21,5.21,0,0,1,.14,3.84,5.59,5.59,0,0,1,1.49,3.89c0,5.57-3.39,6.8-6.62,7.16a3.46,3.46,0,0,1,1,2.68c0,1.94,0,3.5,0,4s.26.84,1,.7A14.5,14.5,0,0,0,14.5.36ZM5.43,21c0,.08-.14.1-.25,0s-.16-.15-.13-.22.15-.09.25-.05S5.47,20.94,5.43,21Zm.71.64a.22.22,0,0,1-.29-.07.21.21,0,0,1,0-.3.22.22,0,0,1,.29.07C6.2,21.45,6.22,21.59,6.14,21.65Zm.49.81c-.09.07-.23,0-.32-.12a.26.26,0,0,1,0-.35c.09-.06.23,0,.33.13S6.72,22.4,6.63,22.46Zm.83.95c-.08.09-.25.06-.37-.06S6.93,23.07,7,23s.25-.06.37.06S7.55,23.32,7.46,23.41Zm1.07.32c0,.11-.2.16-.36.11s-.27-.18-.24-.29.2-.17.36-.12S8.56,23.61,8.53,23.73Zm1.22.13c0,.12-.14.22-.31.22a.28.28,0,0,1-.32-.21c0-.12.14-.22.31-.22S9.75,23.74,9.75,23.86Zm1.19-.05c0,.12-.1.24-.27.27s-.32,0-.34-.15.1-.24.27-.27S10.92,23.7,10.94,23.81Z" fill="#c1c1c1"/>
          </svg>

          <svg
            width="22"
            height="29"
            className="layer p9 firebase"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(10)}
          >
          <g>
            <path d="M-.06,23.41l.17-.25L8.42,7.4l0-.16L4.77.36A.68.68,0,0,0,3.5.57Z" fill="#ffc24a"/>
            <g>
              <path d="M0,23.22.17,23,8.39,7.37,4.74.46A.62.62,0,0,0,3.57.68Z" fill="#f6820c" fillRule="evenodd"/>
              <path d="M0,23.22.17,23,8.39,7.37,4.74.46A.62.62,0,0,0,3.57.68Z" fill="#f6820c"/>
            </g>
            <path d="M11.1,12.44l2.73-2.79L11.1,4.44a.7.7,0,0,0-1.23,0L8.41,7.22v.24Z" fill="#f4bd62"/>
            <g>
              <path d="M11.06,12.32l2.65-2.71-2.65-5a.62.62,0,0,0-1.12,0L8.48,7.33l0,.15Z" fill="#f6820c" fillRule="evenodd"/>
              <path d="M11.06,12.32l2.65-2.71-2.65-5a.62.62,0,0,0-1.12,0L8.48,7.33l0,.15Z" fill="#f6820c"/>
            </g>
            <polygon points="-0.06 23.41 0.02 23.33 0.31 23.21 10.93 12.62 11.07 12.26 8.42 7.21 -0.06 23.41" fill="#f6820c"/>
            <path d="M11.44,28.75l9.62-5.37L18.32,6.47a.66.66,0,0,0-1.12-.36L-.06,23.41,9.5,28.75a2,2,0,0,0,1.94,0" fill="#fde068"/>
            <path d="M21,23.34,18.25,6.55a.57.57,0,0,0-1-.36L0,23.37,9.5,28.66a2,2,0,0,0,1.93,0Z" fill="#fcca3f"/>
            <path d="M11.44,28.59a2,2,0,0,1-1.94,0L0,23.33l-.07.08L9.5,28.75a2,2,0,0,0,1.94,0l9.62-5.37,0-.14Z" fill="#eeab37"/>
          </g>
          </svg>

          <svg
            width="29"
            height="29"
            className="layer p10 vscode"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(23)}
          >
            <path d="M.28,10.16S-.43,9.65.42,9l2-1.77a.84.84,0,0,1,1.16-.07l18.23,13.8v6.61s0,1-1.34.93Z" fill="#2489ca"/>
            <path d="M5,14.42.28,18.69s-.49.36,0,1l2.18,2s.51.56,1.28-.08l5-3.77Z" fill="#1070b3"/>
            <path d="M13.22,14.46l8.61-6.58,0-6.58s-.37-1.44-1.6-.69L8.72,11.05Z" fill="#0877b9"/>
            <path d="M20.44,28.47a1.16,1.16,0,0,0,1.1.35l6.72-3.31A1.42,1.42,0,0,0,29,24.2V4.44a1.31,1.31,0,0,0-.88-1.16L22.29.47a1.63,1.63,0,0,0-2.11.14s1.07-.77,1.6.69V27.42a1.17,1.17,0,0,1-.12.52c-.15.3-.48.59-1.28.47Z" fill="#3c99d4"/>
          </svg>

          <svg
            width="29"
            height="29"
            className="layer p11 realm"
            xmlns="http://www.w3.org/2000/svg"
            style={activeParallax(18)}
          >
            <defs>
              <mask id="a" x="0" y="0.05" width="29" height="28.9" maskUnits="userSpaceOnUse">
                <circle cx="14.54" cy="14.48" r="14.32" fill="#fff"/>
              </mask>
            </defs>
            <g>
              <circle cx="14.54" cy="14.48" r="14.32" fill="#fff"/>
              <g mask="url(#a)">
                <g>
                  <path d="M20.76,1.45A14.49,14.49,0,0,0,4.54,4.06C1.78,6.7,25.65,3.77,20.76,1.45Z" fill="#fcc397"/>
                  <path d="M25.88,5.5S24.7,7.12,21.1,7.58c-7.27.92-19.76,1-19.74,1a14.78,14.78,0,0,1,3.2-4.49,10.26,10.26,0,0,0,4.89.32c2.67-.49,5-2,7.68-2.66a12,12,0,0,1,3.64-.27A14.46,14.46,0,0,1,25.88,5.5Z" fill="#fc9f95"/>
                  <path d="M28.85,12.28c0,.06-16.39,1.6-24.39,1.15a5.93,5.93,0,0,1-4.12-1.8,14.33,14.33,0,0,1,1-3.07A15.83,15.83,0,0,1,9,6.59c3.3,0,6.55,1.14,9.85,1a14.11,14.11,0,0,0,7-2.14A14.39,14.39,0,0,1,28.85,12.28Z" fill="#f77c88"/>
                  <path d="M29,14.47v.24a44.94,44.94,0,0,1-10.42,1.08A181.93,181.93,0,0,1,0,14.35a14.31,14.31,0,0,1,.3-2.81A10.67,10.67,0,0,0,7,13.1a18.82,18.82,0,0,0,5.26-1.6,32.34,32.34,0,0,1,5.16-1.91A13.53,13.53,0,0,1,28.81,12.2,15.45,15.45,0,0,1,29,14.47Z" fill="#f25192"/>
                  <path d="M12.55,19.18C8.2,20,.74,19.06.72,19A14.42,14.42,0,0,1,0,14.47v-.12A12,12,0,0,1,2.18,13a11.36,11.36,0,0,1,6-1.08,20,20,0,0,1,5.86,1.77,49.57,49.57,0,0,0,4.8,1.93C19,15.67,17.34,18.3,12.55,19.18Z" fill="#d34ca3"/>
                  <path d="M28.48,18.38c-.3.51-3.19,2.24-7.11,2.53-5.18.4-11.3-1.17-9.27-2,3.2-1.25,6-3.51,9.27-4.45a12.66,12.66,0,0,1,7.63.26A14.53,14.53,0,0,1,28.48,18.38Z" fill="#9a50a5"/>
                  <path d="M27.13,21.7c-2.5,4.35-20.65,5.44-23.3,2.51A14.36,14.36,0,0,1,.8,19a11.67,11.67,0,0,1,7.34-1.48c3.25.45,6.15,2.26,9.36,3a14.14,14.14,0,0,0,7.81-.5,14.66,14.66,0,0,0,3.23-1.64A14.4,14.4,0,0,1,27.13,21.7Z" fill="#59569e"/>
                  <path d="M27.07,21.64A14.49,14.49,0,0,1,3.75,24.19c.44.17.93.31,1.38.44a14.17,14.17,0,0,0,7.75-.06c1.6-.48,3.11-1.23,4.69-1.8A21.46,21.46,0,0,1,27.07,21.64Z" fill="#39477f"/>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </section>
  );
}

export default Herosection;
